module.exports = __webpack_public_path__ + "img/ticket_hotwallet.gm.d342bd3.png";